<template>
  <div class="relative flex h-full w-full flex-col overflow-hidden rounded-md">
    <img
      v-if="insight?.associated_addresses?.[0]?.street_view_url"
      class="relative z-10 h-full w-full"
      :src="insight?.associated_addresses?.[0]?.street_view_url"
      onerror="this.style.display='none'"
      alt=""
    />
    <div class="absolute inset-0 h-full w-full">
      <div
        class="cont-height no-image-container flex w-full flex-col items-center justify-center"
      >
        <img src="@/assets/no-image-available.svg" />
        <p class="mt-6 text-lg">No image available</p>
      </div>
    </div>
    <div
      v-if="hqAddress?.lat && hqAddress?.lon"
      class="absolute bottom-0 left-0 right-0 z-10 flex h-32 w-full border-t-2 border-yellow-500 bg-yellow-20 text-left"
    >
      <div class="flex h-full w-full justify-between gap-3 p-3 px-6">
        <!-- <router-link :to="{ name: 'CarriersShow', params: { id: markerCarrierData[openedMarkerIndex].id }}" target='_blank' class="text-yellow-600 underline text-xl">
            {{ capitalizeWords(markerCarrierData[openedMarkerIndex].name.toLowerCase()) }}
          </router-link> -->
        <div
          v-if="addressType === 'residential'"
          class="flex gap-6"
        >
          <div class="gap flex w-32 flex-col">
            <h4 class="mb-2 text-2xs font-bold uppercase text-gray-over-dark">
              Residential Address
            </h4>
            <div
              v-if="hqAddress?.street1"
              class="text-xs text-body-color"
            >
              <div class="block">
                {{ hqAddress?.street1 }}
              </div>
              <div
                v-if="hqAddress?.street2"
                class="block"
              >
                {{ hqAddress?.street2 }}
              </div>
              <div class="block">
                {{ hqAddress?.city }}, {{ hqAddress?.state }}
                {{ hqAddress?.postal_code }}
              </div>
            </div>
            <div
              v-else
              class="text-xs text-body-color"
            >
              <div class="block">No address on record</div>
            </div>
          </div>
          <div class="gap flex flex-col">
            <h4 class="mb-2 text-2xs font-bold uppercase text-gray-over-dark">
              Fleet
            </h4>
            <div
              v-if="$store.state.show.showBroker?.operations?.fleet_size"
              class="text-xs text-body-color"
            >
              <div class="block">
                {{ $store.state.show.showBroker?.operations?.fleet_size }}
              </div>
            </div>
            <div
              v-else
              class="text-xs text-body-color"
            >
              <div class="block">No fleet size on record</div>
            </div>
          </div>
          <div class="gap flex w-28 flex-col">
            <h4 class="mb-2 text-2xs font-bold uppercase text-gray-over-dark">
              Phone #
            </h4>
            <div
              v-if="
                $store.state.show.showBroker?.contact_information?.phones?.[0]
                  ?.value
              "
              class="text-xs text-body-color"
            >
              <div class="block">
                {{
                  $store.state.show.showBroker?.contact_information?.phones?.[0]
                    ?.value
                }}
              </div>
            </div>
            <div
              v-else
              class="text-xs text-body-color"
            >
              <div class="block">No phone numbers on record</div>
            </div>
          </div>
          <div class="gap flex flex-col">
            <h4 class="mb-2 text-2xs font-bold uppercase text-gray-over-dark">
              Email
            </h4>
            <div
              v-if="
                $store.state.show.showBroker.contact_information
                  .email_addresses[0]?.value
              "
              class="text-xs text-body-color"
            >
              <div class="block">
                {{
                  $store.state.show.showBroker.contact_information
                    .email_addresses[0].value
                }}
              </div>
            </div>
            <div
              v-else
              class="text-xs text-body-color"
            >
              <div class="block">No email addresses on record</div>
            </div>
          </div>
        </div>
        <div
          v-if="addressType == 'virtual'"
          class="flex gap-6"
        >
          <div
            v-for="address in $store.state.show.showBroker.contact_information?.addresses?.slice(
              0,
              3
            )"
            :key="address?.id"
            class="gap flex flex-col"
          >
            <div
              v-if="checkVirtualAddress(address)"
              class="inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1"
            >
              <div class="flex gap-1">
                <h4
                  class="mb-2 pt-0.5 text-2xs font-bold uppercase text-orange-500"
                >
                  {{ address.is_type?.replaceAll('_', ' ') }} Address
                </h4>
                <svg
                  class="h-4 w-4 flex-shrink text-orange-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                v-if="address?.street1"
                class="flex flex-col items-start text-2xs text-orange-500"
              >
                <div class="block">
                  {{ address?.street1 }}
                </div>
                <div
                  v-if="address.street2"
                  class="block"
                >
                  {{ address?.street2 }}
                </div>
                <div class="block">
                  {{ address?.city }}, {{ address?.state }}
                  {{ address?.postal_code }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="border-2 border-transparent"
            >
              <h4
                class="mb-2 pt-1.5 text-2xs font-bold uppercase text-gray-over-dark"
              >
                {{ address.is_type?.replaceAll('_', ' ') }} Address
              </h4>
              <div
                v-if="address?.street1"
                class="text-2xs text-body-color"
              >
                <div class="block">
                  {{ address?.street1 }}
                </div>
                <div
                  v-if="address?.street2"
                  class="block"
                >
                  {{ address?.street2 }}
                </div>
                <div class="block">
                  {{ address?.city }}, {{ address?.state }}
                  {{ address.postal_code }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="loading-gradient-small hidden h-24 w-36 overflow-hidden rounded-md lg:block"
        >
          <div
            :id="'small-map-' + mapId"
            class="small-insights-map h-full w-full"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// const google = window.google;

export default {
  name: 'GoogleMapStreetViewInsights',
  props: {
    insight: {
      type: Object,
      required: true,
    },
    hqAddress: {
      type: Object,
      required: false,
    },
    mapId: {
      type: String,
      required: true,
    },
    addressType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: true,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
      },
      openedMarkerID: null,
      mapCenter: {
        lat: parseFloat(this.hqAddress?.lat),
        lng: parseFloat(this.hqAddress?.lon),
      },
      // mapMarkers: this.setMapMarkers(),
      gmapScriptLoaded: false,
    };
  },
  watch: {
    gmapScriptLoaded: function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.initializeMap();
      }
    },
  },
  created() {
    this.loadGoogleMapScript();
  },
  mounted() {
    this.loadGoogleMapScript();
    // var self = this;
    // var initMap = setInterval(function () {
    //   let alreadyLoaded = document.getElementById('g-map-script');
    //   if (alreadyLoaded) {
    //     setTimeout(function () {
    //       self.initializeMap();
    //     }, 400);
    //     clearInterval(initMap);
    //   }
    // }, 200);
  },
  methods: {
    checkVirtualAddress: function (address) {
      var isVirtual = false;
      this.insight?.associated_addresses?.forEach(function (item) {
        if (address.id == item.id) {
          isVirtual = true;
        }
      });
      return isVirtual;
    },
    openMarker: function (m) {
      this.openedMarkerID = m.id;
      this.mapMarkers?.forEach(function (el) {
        if (el.id == m.id) {
          el.opened = true;
        } else {
          el.opened = false;
        }
      });
    },
    // closeMarker: function(id) {
    //   console.log('closeMarker');
    //   var self = this;
    //    this.openedMarkerID = id;
    //    this.insight.addresses.forEach(function(el, index) {
    //      if (el.id == id) {
    //        console.log('closing Marker - '+el.id);
    //        self.mapMarkers[index].opened = false;
    //        console.log('closed Marker - '+el.id);
    //      }
    //    });
    // },
    centerMarker: function (m) {
      var self = this;
      this.openedMarkerID = m.id;
      this.mapMarkers.forEach(function (el) {
        if (el.id == m.id) {
          self.mapCenter = {
            lat: el.position.lat,
            lng: el.position.lng,
          };
          el.opened = true;
        } else {
          el.opened = false;
        }
      });
    },
    // viewStreet: function(m) {
    //   const contactInfoStreetView = this.$refs.contactInfoStreetView;
    //   const panorama = new window.google.maps.StreetViewPanorama(
    //     document.getElementById("pano"),
    //     {
    //       position: m.position,
    //       pov: {
    //         heading: 34,
    //         pitch: 10,
    //       },
    //     }
    //   );

    //   contactInfoStreetView.setStreetView(panorama);
    // },
    // setMapMarkers: function() {
    //   var self = this;
    //   var markers = [];
    //   this.insight.addresses.forEach(function(el, index) {
    //     markers.push({
    //       id : el.id,
    //       label : self.capitalizeWords(el.is_type)+' Address',
    //       position : {
    //         lat : parseFloat(el.lat),
    //         lng : parseFloat(el.lon)
    //       },
    //       opened: index == 0 ? true : false,
    //     });
    //   });
    //   return markers;
    // },
    capitalizeWords: function (str) {
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    },
    initializeMap: function () {
      // var self = this;
      const map = document.getElementById('small-map-' + this.mapId);
      var mapIcon = {
        url: "data:image/svg+xml,%3Csvg width='18' height='25' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.804225 14.1393C2.61519 18.4453 5.92803 22.0825 7.73186 23.8596C8.43462 24.5519 9.52789 24.5478 10.2266 23.8514C12.0125 22.0714 15.2936 18.4387 17.1619 14.1393C19.8207 8.02079 15.9 0.390625 8.98305 0.390625C2.0661 0.390625 -1.76901 8.02079 0.804225 14.1393Z' fill='%23313545'/%3E%3Ccircle cx='8.94023' cy='9.13188' r='3.17875' fill='white'/%3E%3C/svg%3E%0A",
      };
      if (map !== null) {
        let smallMap = new window.google.maps.Map(map, {
          center: this.mapCenter,
          zoom: 12,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          disableDefaultUI: true,
        });
        new window.google.maps.Marker({
          position: this.mapCenter,
          map: smallMap,
          icon: mapIcon,
        });
      }

      // const panorama = new window.google.maps.StreetViewPanorama(
      //   document.getElementById(this.mapId),
      //   {
      //     position: self.mapCenter,
      //     pov: {
      //       heading: 270,
      //       pitch: 10,
      //     },
      //   }
      // );

      // var iconShowCarrier = {
      //     url: "data:image/svg+xml,%3Csvg width='18' height='25' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.804225 14.1393C2.61519 18.4453 5.92803 22.0825 7.73186 23.8596C8.43462 24.5519 9.52789 24.5478 10.2266 23.8514C12.0125 22.0714 15.2936 18.4387 17.1619 14.1393C19.8207 8.02079 15.9 0.390625 8.98305 0.390625C2.0661 0.390625 -1.76901 8.02079 0.804225 14.1393Z' fill='%23f8c617'/%3E%3Ccircle cx='8.94023' cy='9.13188' r='3.17875' fill='white'/%3E%3C/svg%3E%0A",
      //     scaledSize: new window.google.maps.Size(18, 25)
      // };

      // const hqMarker = new window.google.maps.Marker({
      //   position: self.mapCenter,
      //   map,
      //   icon: iconShowCarrier,
      //   title: self.capitalizeWords(self.$store.state.show.showBroker.name.toLowerCase()),
      // });

      // map.setStreetView(panorama);
    },
    loadGoogleMapScript: async function () {
      var self = this;
      let alreadyLoaded = document.getElementById('google-autocomplete-script');

      if (!alreadyLoaded) {
        let gMapScript = document.createElement('script');
        gMapScript.setAttribute(
          'src',
          'https://maps.googleapis.com/maps/api/js?key=' +
            process.env.GOOGLE_MAPS_API_KEY +
            '&v=weekly&callback=Function.prototype'
        );
        gMapScript.setAttribute('async', '');
        // gMapScript.setAttribute('defer', '');
        gMapScript.setAttribute('id', 'g-map-script');
        await document.body.appendChild(gMapScript);
        gMapScript.addEventListener('load', function () {
          self.gmapScriptLoaded = true;
        });
      } else {
        if (typeof window.google == 'undefined') {
          alreadyLoaded.addEventListener('load', function () {
            self.gmapScriptLoaded = true;
          });
        } else {
          this.gmapScriptLoaded = true;
        }
      }
    },
  },
};
</script>

<style>
.small-insights-map .gmnoprint {
  opacity: 0 !important;
}
.small-insights-map > div > div.gm-style > div:last-of-type,
.small-insights-map
  > div
  > div.gm-style
  a[title='Open this area in Google Maps (opens a new window)'] {
  display: none !important;
  opacity: 0 !important;
}
</style>
<style scoped>
.no-image-container {
  background: #fffdee;
  color: rgba(169, 173, 189, 1);
  height: calc(100% - 8rem);
}
</style>
